import React from "react";
import clsx from "clsx";
import moment from "moment";
import NextStateModal from "./NextStateModal";
import queryString from "query-string";
import SofIcon from "../common/Icons";
import { ActivityLog, SofView } from "../../models";
import { ActivityService } from "../../services/ActivityService";
import { ChoiceGroup } from "@fluentui/react";
import { DatePicker } from "@fluentui/react";
import { DirectionalHint } from "@fluentui/react";
import { ExecuteAction1 } from "../../models";
import { Fragment } from "react";
import { IChoiceGroupOption } from "@fluentui/react";
import { Icon } from "@fluentui/react";
import { IShimmerElement } from "@fluentui/react";
import { ISofProps } from "./SofPage";
import { LineHandling } from "../../models";
import { MaskedTextField } from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react";
import { NextActionType } from "./NextStateModal";
import { Nomination } from "../../models";
import { Post } from "../../api/apiUtils";
import { ProcessFlowAction } from "../../models";
import { ProcessFlowStep } from "../../models";
import { pushNotification } from "../../api/pushNotification";
import { Shimmer } from "@fluentui/react";
import { ShimmerElementType } from "@fluentui/react";
import { SofProcessor } from "../../services/SofProcessor";
import { Spinner } from "@fluentui/react";
import { SpinnerSize } from "@fluentui/react";
import { TeachingBubble } from "@fluentui/react";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";

interface IStepProps extends ISofProps {
  step: ProcessFlowStep;
  readonly: boolean;
  onStateChange(
    newState: string,
    lineHandling: LineHandling,
    activityLogs: ActivityLog[]
  ): void;
}

interface IActionProps extends IStepProps {
  actions: ProcessFlowAction[];
  activities: ActivityLog[];
  status: number;
  onStateChange(
    newState: string,
    lineHandling: LineHandling,
    activityLogs: ActivityLog[]
  ): void;
}

const classes = mergeStyleSets({
  container: {
    height: "100%",
    padding: 12
  },
  innerContainer: {
    padding: 6,
    height: "100%",
    display: "flex",
    background: "#FFFFFF",
    flexDirection: "column"
  },
  inputGroup: {
    display: "flex",
    flexDirection: "row",
    gap: 8
  },
  inputField: {
    display: "inline"
  },
  disabledBG: {
    background: "rgba(255, 255, 255, 0.4)",
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    width: "60%",
    zIndex: 999
  },
  columnHeader: {
    borderBottom: "1px solid #E2E6E8",
    fontWeight: "bold",
    color: "#7C7777",
    display: "flex",
    padding: "12px 0",
    alignItems: "center"
  },
  dataRow: {
    borderBottom: "1px solid #E2E6E8",
    color: "#4C4C4C",
    display: "flex",
    fontWeight: 700,
    padding: "16px 0",
    alignItems: "center"
  },
  dataCellFlex: {
    textTransform: "capitalize",
    flexGrow: 1
  },
  dataCell: {
    width: 320
  },
  textBoxOffline: {
    color: "rgb(184, 184, 184)"
  },
  textBoxError: {
    border: "1px solid rgb(168, 0, 0)"
  },
  textBoxEdited: {
    backgroundColor: "#DBEFDC",
    border: "1px solid #4CAF50"
  },
  iconContainer: {
    display: "flex",
    alignItems: "center"
  },
  iconStyle: {
    color: "rgb(168, 0, 0)"
  },
  showIcon: {
    width: 32,
    height: 32,
    color: "#12427D",
    opacity: 1,
    transition: "all 250ms linear"
  },
  hideIcon: {
    opacity: 0,
    width: 0,
    transition: "all 250ms linear 5s"
  }
});

const ActivityGridAction = (props: IActionProps) => {
  const {
    actions,
    activities,
    correlationId,
    lineHandling,
    nomination,
    selectedState,
    step
  } = props;
  const [order, setOrder] = useState(1);
  const [isError, setIsError] = useState(false);
  const [activityId, setActivityId] = useState(0);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOffline, setIsOffline] = useState(false);
  const [isEditable, setIsEditable] = useState(true);
  const [surveyor, setSurveyor] = useState<string>();
  const [dateValue, setDateValue] = useState<Date>();
  const [description, setDescription] = useState("");
  const [timeValue, setTimeValue] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [mainAction, setMainAction] = useState<ProcessFlowAction>();
  const [activityTimestamp, setActivityTimestamp] = useState<string>();
  const [currentActivity, setCurrentActivity] = useState<ActivityLog>();
  const [actionOptions, setActionOptions] = useState<IChoiceGroupOption[]>([]);
  const maskFormat = {
    "1": /[0-2]/,
    "2": /[0-9]/,
    "3": /[0-5]/
  };

  const onEditDate = (date: Date | null | undefined) => {
    if (date) {
      setDateValue(date);

      if (timeValue) {
        const h = parseInt(timeValue.substring(0, 2));
        const m = parseInt(timeValue.substring(3));
        if (!Number.isInteger(h) || !Number.isInteger(m)) {
          setErrorMessage("Invalid timestamp.");
          setIsError(true);
          return;
        }
        date.setHours(h);
        date.setMinutes(m);
        if (date > new Date()) {
          setErrorMessage(
            "Timestamp must not be greater than the current time."
          );
          setIsError(true);
          return;
        }

        setIsError(false);
        if (activityTimestamp) {
          submitEditTimestamp(date.toISOString());
        } else {
          if (mainAction) {
            submitExecuteAction(date.toISOString(), mainAction.id);
          }
        }
      }
    }
  };

  const onEditTime = (_e: any, value?: string) => {
    if (value) {
      value = value.replace("_", "");
      setTimeValue(value);

      if (dateValue === undefined) return;
      if (!validateTimestamp(value)) {
        return;
      }

      const date = new Date(dateValue);
      const hour = parseInt(value.substring(0, 2));
      const minute = parseInt(value.substring(3));
      if (hour > 23 || minute > 59) {
        setErrorMessage("Invalid date");
        setIsError(true);
        return;
      }
      date.setHours(hour);
      date.setMinutes(minute);

      if (date > new Date()) {
        setErrorMessage("Timestamp must not be greater than the current time.");
        setIsError(true);
        return;
      }

      setIsError(false);
      if (activityTimestamp) {
        submitEditTimestamp(date.toISOString());
      } else {
        if (mainAction) {
          submitExecuteAction(date.toISOString(), mainAction.id);
        }
      }
    }
  };

  const onOtherAction = (e: any, option?: IChoiceGroupOption) => {
    if (option) {
      const now = new Date();
      submitExecuteAction(now.toISOString(), parseInt(option.key));
    }
  };

  const validateDateRange = (start?: string, end?: string): boolean => {
    if (start && end) {
      return new Date(start) < new Date(end);
    }
    return true;
  };

  const validateTimestamp = (end: string, start?: string): boolean => {
    var result =
      (start === undefined || start.length === 5) && end.length === 5;

    setIsError(!result);
    return result;
  };

  const submitEditTimestamp = async (timestamp: string) => {
    setIsError(false);
    setErrorMessage(undefined);
    if (activities === undefined) return;
    try {
      const _activity = activities.find((f) => f.id === activityId);
      if (_activity === undefined) return;
      const startActivityId = _activity.status === 1 ? _activity.id : 0;
      const finishedActivityId = _activity.status === 2 ? _activity.id : 0;

      if (startActivityId > 0) {
        const endAct = activities.find((f) => f.status === 2);
        if (
          endAct &&
          !validateDateRange(
            timestamp,
            moment(`${endAct.logTime} UTC`).toISOString()
          )
        ) {
          setErrorMessage("Start time can not be later than end time.");
          setIsError(true);
          return;
        }
      }
      if (finishedActivityId > 0) {
        const startAct = activities.find((f) => f.status === 1);
        if (
          startAct &&
          !validateDateRange(
            moment(`${startAct.logTime} UTC`).toISOString(),
            timestamp
          )
        ) {
          setErrorMessage("End time can not be earlier than start time.");
          setIsError(true);
          return;
        }
      }

      const payload = {
        startActivityId,
        finishedActivityId,
        startedOn: timestamp,
        finishedOn: timestamp,
        correlationId
      };
      setIsLoading(true);
      const lineHandlingNo = lineHandling.result
        ? lineHandling.result.lineHandlingNo
        : "0";
      const response = await Post(
        `/api/v1.5/linehandling/${lineHandlingNo}/activities/timestamp`,
        JSON.stringify(payload)
      );
      setIsLoading(false);
      if (response.ok) {
        const result = await response.json();
        setIsSuccess(true);
        setIsError(false);
        props.insertActivityLogs(result);
      } else {
        setErrorMessage("Unable to save changes. Please try to reconnect.");
        setIsError(true);
      }
    } catch {
      setIsError(true);
      setIsLoading(false);
      setErrorMessage("Unable to save changes. Please try to reconnect.");
    }
  };

  const submitExecuteAction = async (timestamp: string, actionId: number) => {
    const activityService = new ActivityService();
    const lineHandlingNo = lineHandling.result
      ? lineHandling.result.lineHandlingNo
      : "0";
    const nominationNo = nomination && nomination.nominationNo;

    setIsLoading(true);
    const exeActivity = {
      lineHandlingNo,
      stepId: step.id,
      nominationNo,
      actionId,
      executionTime: timestamp,
      order,
      surveyor,
      correlationId
    } as ExecuteAction1;

    try {
      const result = await activityService.executeActionAsync(
        exeActivity,
        props.account.accountIdentifier,
        () => props.insertOfflineData(lineHandlingNo, exeActivity)
      );
      let _lineHandling =
        lineHandling.result !== undefined
          ? lineHandling.result
          : ({} as LineHandling);

      setIsSuccess(true);
      if (result.result) {
        let nominations: Nomination[] | undefined = [];

        nominations = lineHandling.result && lineHandling.result.nominations;
        if (result.result.nominations && nominations) {
          for (let n of result.result.nominations) {
            let nom: Nomination | undefined = nominations.find(
              (f) =>
                f.nominationNo.toLowerCase() === n.nominationNo.toLowerCase()
            );

            if (nom)
              nominations = [
                ...nominations.filter((f) => f.nominationNo !== n.nominationNo),
                { ...nom, ...n }
              ];
          }
        }

        _lineHandling = {
          ...props.lineHandling.result,
          ...result.result,
          nominations
        };
        props.setLineHandling(_lineHandling);
        if (nomination) {
          props.setActiveNomination(nomination.nominationNo, false);
        }
      }

      props.insertActivityLogs(result.activities, (activityLogs) => {
        if (result.newState && result.newState !== selectedState) {
          props.onStateChange(result.newState, _lineHandling, activityLogs);
          //props.setSelectedState(result.newState);
        }
      });
    } catch (ex) {
      const error = ex as Error;
      if (error && error.message) {
        setErrorMessage(
          error.message === "Action cannot perform"
            ? "End time must not be earlier than Start time."
            : error.message
        );
      } else {
        setErrorMessage("Unexpected error occurs. Please try again.");
      }
      setIsError(true);
    }
    setIsLoading(false);
  };

  const resetValues = () => {
    setOrder(1);
    setActivityId(0);
    setIsOffline(false);
    setDateValue(undefined);
    setTimeValue(undefined);
    setActivityTimestamp(undefined);
  };

  useEffect(() => {
    if (activities && activities.length > 0 && mainAction) {
      const _currentActivity = activities.sort((a, b) => b.id - a.id)[0];
      if (_currentActivity) {
        setCurrentActivity(_currentActivity);
        const actionActivity = activities.find(
          (f) => f.status == mainAction.type
        );
        if (actionActivity) {
          const _timestamp = actionActivity.offline
            ? moment(new Date(actionActivity.logTime))
            : moment(`${actionActivity.logTime} UTC`).local();

          setActivityId(actionActivity.id);
          setDateValue(_timestamp.toDate());
          setIsOffline(actionActivity.offline);
          setTimeValue(_timestamp.format("HH:mm"));
          setOrder(actionActivity.repetitionOrder);
          setActivityTimestamp(actionActivity.logTime);
        } else {
          resetValues();
        }

        setIsEditable(
          _currentActivity.status === mainAction.type ||
            _currentActivity.status === mainAction.displayAt ||
            activities.filter((f) => f.status === mainAction.type).length > 0
        );
      } else {
        resetValues();
      }
    } else {
      setIsEditable(false);
    }
  }, [mainAction, activities]);

  useEffect(() => {
    if (actions.length > 0) {
      setMainAction(actions[0]);
      setDescription(actions[0].name);
      if (actions.length > 1) {
        setActionOptions(
          actions
            .slice(1)
            .filter((a) =>
              SofProcessor.checkConditions(
                a.displayConditions,
                props.lineHandling.result,
                props.nomination,
                props.activityLogs.result ? props.activityLogs.result : []
              )
            )
            .map(
              (a) =>
                ({
                  key: a.id.toString(),
                  text: a.caption,
                  disabled: currentActivity?.status !== a.displayAt
                } as IChoiceGroupOption)
            )
        );
      }
    }
  }, [actions, currentActivity]);

  return (
    <div className={clsx(classes.dataRow)}>
      <div className={clsx(classes.dataCellFlex)}>{description}</div>

      <ChoiceGroup
        options={actionOptions}
        onChange={onOtherAction}
        disabled={isLoading || props.readonly || !isEditable}
        style={{ paddingRight: 16 }}
        selectedKey={currentActivity?.processActionId?.toString()}
      />

      <div className={clsx(classes.dataCell)}>
        {mainAction && (
          <div className={classes.inputGroup}>
            <DatePicker
              id={`txt-date-${mainAction.id}`}
              className={classes.inputField}
              textField={{
                inputClassName: clsx(
                  isError && !props.readonly ? classes.textBoxError : undefined,
                  isOffline ? classes.textBoxOffline : undefined
                )
              }}
              formatDate={(val?: Date) => (val ? moment(val).format("ll") : "")}
              onSelectDate={onEditDate}
              disabled={isLoading || props.readonly || !isEditable}
              value={dateValue}
              maxDate={new Date()}
              placeholder="Enter date"
              showMonthPickerAsOverlay
              style={{ minWidth: 193 }}
            />
            <MaskedTextField
              id={`txt-time-${mainAction.id}`}
              className={classes.inputField}
              inputClassName={clsx(
                isError && !props.readonly ? classes.textBoxError : undefined,
                isOffline ? classes.textBoxOffline : undefined
              )}
              mask="12:32"
              maskFormat={maskFormat}
              disabled={isLoading || props.readonly || !isEditable}
              onChange={onEditTime}
              value={timeValue}
              style={{ width: 90 }}
              iconProps={{ iconName: "Clock" }}
            />
            {isError && (
              <div className={classes.iconContainer}>
                <Icon
                  id={`icon-action-${step.id}-${props.status}`}
                  iconName="StatusErrorFull"
                  className={classes.iconStyle}
                />
              </div>
            )}

            {!isError && (
              <div
                className={clsx(
                  classes.iconContainer,
                  isSuccess ? classes.showIcon : classes.hideIcon
                )}
                onTransitionEnd={() => {
                  console.log("onTransitionEnd");
                  setIsSuccess(false);
                }}
              >
                <Icon iconName="SkypeCircleCheck" />
              </div>
            )}

            {isLoading && <Spinner size={SpinnerSize.small} />}
          </div>
        )}
      </div>
      {errorMessage && (
        <TeachingBubble
          target={`#icon-action-${step.id}-${props.status}`}
          calloutProps={{ directionalHint: DirectionalHint.bottomRightEdge }}
          onDismiss={() => setErrorMessage(undefined)}
        >
          {errorMessage}
        </TeachingBubble>
      )}
    </div>
  );
};

const ActivityGridStep = (props: IStepProps) => {
  const { activityLogs, step, nomination } = props;
  const [startActions, setStartActions] = useState<ProcessFlowAction[]>([]);
  const [endActions, setEndActions] = useState<ProcessFlowAction[]>([]);
  const [activities, setActivities] = useState<ActivityLog[]>([]);

  useEffect(() => {
    if (step) {
      setStartActions(step.actions.filter((f) => f.displayAt === 0));
      setEndActions(step.actions.filter((f) => f.displayAt === 1));

      if (activityLogs.result) {
        const nominationNo = nomination?.nominationNo;
        setActivities(
          activityLogs.result.filter(
            (f) =>
              f.nominationNo === nominationNo && f.processStepId === step.id
          )
        );
      }
    }
  }, [step, activityLogs.result, nomination]);

  return (
    <Fragment>
      {startActions.length > 0 && (
        <ActivityGridAction
          key={`step=${step.id}-1`}
          {...props}
          status={1}
          step={step}
          actions={startActions}
          activities={activities}
          readonly={props.readonly}
          onStateChange={props.onStateChange}
        />
      )}
      {endActions.length > 0 && (
        <ActivityGridAction
          key={`step=${step.id}-2`}
          {...props}
          status={2}
          step={step}
          actions={endActions}
          activities={activities}
          readonly={props.readonly}
          onStateChange={props.onStateChange}
        />
      )}
    </Fragment>
  );
};

const ActivitiesGrid = (props: ISofProps) => {
  const { activityLogs, config, selectedState, sofView, nomination } = props;
  const [steps, setSteps] = useState<ProcessFlowStep[]>([]);
  const [lineHandlingNo, setLineHandlingNo] = useState("");
  const [newState, setNewState] = useState("");
  const [readonly, setReadonly] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showNewStateModal, setShowNewStateModal] = useState(false);
  const [nextActionType, setNextActionType] = useState(
    NextActionType.NEXT_STATE
  );
  const history = useHistory();
  const activeStatus = [0, 1, 2, 5];
  const shimmers: IShimmerElement[] = [
    { type: ShimmerElementType.line, height: 36 }
  ];

  const onStateChange = (
    newState: string,
    _lineHandling: LineHandling,
    updatedActivityLogs: ActivityLog[]
  ) => {
    let nextActionType: NextActionType = NextActionType.NEXT_STATE;
    let msg: string = `${selectedState} operations are done. Proceed to ${newState} to continue.<br />Click "Ok" to proceed to the next stage, or "Cancel" to remain in the current view.`;
    const nominationNo = nomination && nomination.nominationNo;
    const activeActivities = SofProcessor.getCurrentActivityPerStep(
      updatedActivityLogs
    ).filter(
      (f) =>
        f.state === newState &&
        (nomination === undefined ||
          f.nominationNo === nomination.nominationNo) &&
        activeStatus.indexOf(f.status) >= 0
    );

    if (!nominationNo) {
      if (_lineHandling.status === 3) {
        msg = "All operations for this line handling are complete.";
        nextActionType = NextActionType.FINISHED;
      } else {
        if (activeActivities && activeActivities.length > 0) {
          // default values
        } else {
          const hasaActiveNominations = _lineHandling.nominations.filter(
            (f) => f.status < 2
          );
          if (hasaActiveNominations) {
            msg = `${selectedState} operations are done. No current operation for Line Handling. To continue, select a nomination.`;
            nextActionType = NextActionType.SELECT_NOMINATION;
          } else {
            msg = "This Line Handling is done";
            nextActionType = NextActionType.FINISHED;
          }
        }
      }
    } else {
      if (activeActivities && activeActivities.length > 0) {
        // default values
      } else {
        const activeNominations = _lineHandling.nominations.filter(
          (f) => f.status < 2
        );
        if (activeNominations.length > 0) {
          msg = `This nomination is done. Please select a different nomination to continue.`;
          nextActionType = NextActionType.SELECT_NOMINATION;
        } else {
          msg =
            "All nominations are done. Go back to Line Handling view to proceed.";
          nextActionType = NextActionType.BACK_TO_LINE_HANDLING;
        }
      }
    }

    setNewState(newState);
    setModalMessage(msg);
    setNextActionType(nextActionType);
    setShowNewStateModal(true);
  };

  const renderMessage = (message: string) => (
    <div key="msg" className="no-activity">
      <SofIcon iconname="Exclamation" />
      <p key="no-activity">{message}</p>
    </div>
  );

  useEffect(() => {
    if (config && selectedState) {
      const state = config.states.find((f) => f.name === selectedState);
      if (!state) return;

      setSteps(
        config.steps
          .filter((f) => f.processFlowStateId === state.id)
          .sort((a, b) => a.order - b.order)
      );
    }

    if (props.lineHandling.result) {
      setLineHandlingNo(props.lineHandling.result.lineHandlingNo);
    }
  }, [selectedState]);

  useEffect(() => {
    setReadonly(
      !props.isMarineEditActivityAllowed ||
        (props.lineHandling.result !== undefined &&
          props.lineHandling.result.status === 4)
    );

    pushNotification.connection.off("ActionExecuted");
    pushNotification.connection.off("NominationAdded");

    pushNotification.connection.on("ActionExecuted", (message) => {
      const { search } = history.location;
      const q = queryString.parse(search.toLowerCase());
      const linehandlingno = q.linehandling as string;
      const nominationno = q.nomination as string | undefined;
      var result = message as string[];
      let cnt = 0;

      if (
        result[0].toUpperCase() === linehandlingno.toUpperCase() &&
        result[1] !== props.correlationId &&
        cnt === 0
      ) {
        cnt += 1;
        props.getActivityLogs(result[0].toUpperCase(), () => {
          props.getLineHandling(
            linehandlingno,
            nominationno,
            false,
            false,
            () => {
              let previousPage = `?lineHandling=${result[0]}`;
              if (nominationno) {
                previousPage += `&nomination=${nominationno}`;
              }
              if (
                history.location.search.toUpperCase() !==
                previousPage.toUpperCase()
              ) {
                history.push(`/sof${previousPage}`);
              }
            }
          );
        });
      }
    });

    pushNotification.connection.on("NominationAdded", (message) => {
      const { search } = history.location;
      const q = queryString.parse(search.toLowerCase());
      const linehandlingno = q.linehandling as string;
      const nominationno = q.nomination as string | undefined;
      let cnt = 0;

      if (message.toUpperCase() === linehandlingno.toUpperCase() && cnt === 0) {
        props.getActivityLogs(message.toUpperCase(), () => {
          props.getLineHandling(
            lineHandlingNo,
            nominationno,
            false,
            true,
            () => {
              cnt += 1;

              let previousPage = `?lineHandling=${message}`;
              if (nominationno) {
                previousPage += `&nomination=${nominationno}`;
              }
              if (
                history.location.search.toUpperCase() !==
                previousPage.toUpperCase()
              ) {
                history.push(`/sof${previousPage}`);
              }
            }
          );
        });
      }
    });

    return () => {
      pushNotification.connection.off("ActionExecuted");
      pushNotification.connection.off("NominationAdded");
    };
  }, [lineHandlingNo]);

  return (
    <div className={clsx("activities-pane", classes.innerContainer)}>
      {selectedState && (
        <NextStateModal
          currentState={selectedState}
          nextState={newState}
          message={modalMessage}
          display={showNewStateModal}
          actionType={nextActionType}
          onClick={() => {
            setShowNewStateModal(false);
            switch (nextActionType) {
              case NextActionType.NEXT_STATE:
                props.setSelectedState(newState);
                break;
              case NextActionType.SELECT_NOMINATION:
                props.setSelectedState(newState);
                break;
              case NextActionType.BACK_TO_LINE_HANDLING:
                if (props.lineHandling.result) {
                  props.setSelectedState(
                    props.lineHandling.result.currentState
                  );
                  history.push(`/marine/${lineHandlingNo}/sof`);
                }
                break;
              case NextActionType.FINISHED:
                break;
            }
          }}
          onCancel={() => setShowNewStateModal(false)}
        />
      )}

      <div className={classes.innerContainer}>
        {sofView === SofView.NominationEdit && (
          <div className={classes.disabledBG} />
        )}

        {activityLogs.isLoading && (
          <Fragment>
            <Shimmer shimmerElements={shimmers} style={{ paddingBottom: 24 }} />
            <Shimmer shimmerElements={shimmers} style={{ paddingBottom: 24 }} />
            <Shimmer shimmerElements={shimmers} style={{ paddingBottom: 24 }} />
          </Fragment>
        )}

        {!activityLogs.isLoading &&
          sofView === SofView.None &&
          renderMessage(
            "Activities will appear after selecting a nomination.."
          )}

        {!activityLogs.isLoading &&
          sofView !== SofView.None &&
          steps.length === 0 &&
          renderMessage("No activity to show in the current view..")}

        {!activityLogs.isLoading &&
          sofView !== SofView.None &&
          steps.length > 0 && (
            <div>
              <div>
                <div className={classes.columnHeader}>
                  <div className={classes.dataCellFlex}>Activity</div>
                  <div className={classes.dataCell}>Timestamp</div>
                </div>
              </div>
              <div className="custom-scroll">
                <div>
                  {steps.map((step) => (
                    <ActivityGridStep
                      key={step.id}
                      {...props}
                      step={step}
                      readonly={readonly}
                      onStateChange={onStateChange}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};
export default ActivitiesGrid;
